import {
  always,
  concat,
  cond,
  contains,
  equals,
  filter,
  head,
  includes,
  isEmpty,
  join,
  lensPath,
  map,
  pathOr,
  set,
  split,
  sum,
  T,
  length,
  find,
  subtract,
  divide,
  toLower,
  flatten,
  reduce,
} from 'ramda';
import { compose } from 'recompose';
import { ADVISOR_DASHBOAD, APP_ROOT } from 'src/route_constants';
import {
  EVENTS_ACTION_CREDIT_CHECK,
  EVENTS_SOURCE_EXPERIAN,
  MORTGAGE,
} from 'src/features/constants';
import {
  ADIVSOR_ONELOAN_ACTIVITY_PERMISSION,
  ADVISOR_ADMINCENTER_MENU_PERMISSION,
  ADVISOR_ALL_PAYMENT_ACTIVITY_PERMISSIONS,
  ADVISOR_APPLICATIONS_PERMISSIONS,
  ADVISOR_APPROVAL_ACTIVITY_PERMISSIONS,
  ADVISOR_ADMINCENTER_BANK_ACCOUNTS_PERMISSIONS,
  ADVISOR_DASHBOARD_REPORT_PERMISSIONS,
  ADVISOR_NOTIFICATIONS_PERMISSIONS,
  ADVISOR_TASKS_PERMISSIONS,
  ADVISOR_ADMINCENTER_USERS_PERMISSION,
  ADIVSOR_ONELOAN_CHAT_PERMISSION,
  DOCUMENT_PERMISSION,
  FINANCIAL_REPORTS_PERMISSION,
  MANAGE_ACCESS_PERMISSIONS,
  ADVISOR_ONELOAN_NOTES_PERMISSION,
  ADVISOR_ONELOAD_OVERVIEW_PERMISSION,
  ADIVSOR_ONELOAN_TASK_PERMISSION,
  LOAN_PRODUCT_ADVISOR_PERMISSION,
  BANK_ACCOUNT_PERMISSION,
  PAYMENT_SCHEDULE_PERMISSION,
  PAYMENT_ACTIVITIES_PERMISSION,
  UW_DECISION_PERMISSION,
  ADMIN_MANAGE_DIRECTORY_PERMISSION,
  ADVISOR_ADMINCENTER_MORTGAGE_RATES_PERMISSIONS,
  ADVISOR_ADMINCENTER_GLOBAL_SETTINGS_MENU,
  ADVISOR_ADMINCENTER_BRANCH_MENU,
  ADVISOR_ADMINCENTER_VARMAPS_VIEW,
  ADVISOR_DASHBOARD_MY_TEAMS_WRITE,
  ADVISOR_ADMINCENTER_ALL_TEAMS_VIEW,
  ADVISOR_TABS_ADD_NEW_APPLICATION_PERMISSIONS,
  ADVISOR_DASHBOARD_HELP_CENTER_PERMISSIONS,
  ADVISOR_DASHBOARD_HELP_CENTER_VIDEOS_VIEW,
  ADVISOR_DASHBOARD_HELP_CENTER_SHAREPOINTS_VIEW,
  ADVISOR_ADMINCENTER_SITE_BRANDING
} from 'src/features/RBAC/Rules/permissionData';
import { DATA_PATH_SEPERATOR } from 'src/features/Signatures/ESignProviders/DocuSign/TemplateMatcher';
import { useEventsBridgeHook } from 'src/hooks/useEvents';
import {
  BORROWER,
  KIND_LOAN_STATUS,
  KIND_LOANAPP,
  KIND_LOANAPP_ROLE,
  META_DATA,
  OBJECT_META,
  STATUS_ACTIVE,
  STATUS_ARCHIVED,
  STATUS_DECLINED,
  STATUS_NOT_FUNDED,
  STATUS_SAVED_PREQUALIFICATION,
  TYPE_OF_LOAN,
  LOAN_PRODUCT_ID,
  LABELS,
  doNothingPass,
  STATUS_WITHDRAW,
} from 'src/services/constants';
import { setOwnerReference } from 'src/services/objects/build';
import { getNamespaceId, getNamespaceName } from 'src/services/objects/namespaces';
import { MERCHANTCASHADVANCES } from 'src/features/LoansHome/Products/constants';
import {
  currencyFormatterWithOutSymbol,
  formartContractCurrencyFn,
} from 'src/utilities/formatCurrency';
import { isNotEmpty, returnIsNotEmptyOrTrue } from 'src/utilities/hasValue';
import { buildLabel, getFullName } from 'src/utilities/naming';
import { pruneAddress } from 'src/utilities/properties';
import { getMemberPersona } from 'src/utilities/team';
import { traverseBF } from 'src/utilities/tree';
import { mapIndexed } from 'src/utilities/visualFieldsMapper';
import { filterLoanStages } from 'src/features/core/ChatEngine/Configs/lonStagesConfig/config';
import {
  APPLICANT_CONTRACT,
  BC_APPLICANT_CONTRACT_DOCUMENT_NAME,
  DOCUMENT_REPRESENTS_APPLICANT_CONTRACT,
} from 'src/components/CheckLists/documents';
import useNotification from '../ToastNotifications/ToastNotifications';
import { getContractInputFields } from '../Signatures/ESignProviders/DocuSign/templates/0000_applicationTemplate';
import moment from 'moment';
import {
  DOWNCASE_DAILY_INTERVAL_PERIOD,
  DOWNCASE_MONTHLY_INTERVAL_PERIOD,
  DOWNCASE_WEEKLY_INTERVAL_PERIOD,
  JOIN_SEMIMONTHLY_INTERVAL_PERIOD_NAME,
} from './constants';
import {
  C_CORP,
  C_CORP_LABEL,
  LLC,
  LLC_LABEL,
  NON_PROFIT_ORGANISATION,
  NON_PROFIT_ORGANISATION_LABEL,
  NON_PROFIT_ORGANIZATION,
  NON_PROFIT_ORGANIZATION_LABEL,
  OTHERS,
  PARTNERSHIP,
  PARTNERSHIP_LABEL,
  SOLE_PROPRIETOR,
  SOLE_PROPRIETOR_LABEL,
} from '../ApplicationWorkflows/SBAPPP/constants';
import SiteSettings from 'src/siteSetting';
import { getOneLoanAppURL } from 'src/services/objects/loanApp';
import { dateWithTimeStamp } from 'src/utilities/formatDate';
import { APP_LS_NAMESPACE_ID } from 'src/constants';
import siteSetting from 'src/siteSetting';
import { canGuard } from '../RBAC/Can';
import { getTheCoBorrowerRoleId } from 'src/utilities/borrowers';


export const NOT_ARCHIVED = [STATUS_NOT_FUNDED, STATUS_ARCHIVED];

export const mkPaymentApprovalRedirectUrl = (data: any) => {
  return `${APP_ROOT}/internal/applications/${pathOr(
    '',
    ['loanId'],
    data
  )}/paymentactivities?loanType=${MERCHANTCASHADVANCES}?thisurl=Payment Activities`;
};

export const mkTaskRedirectionUrl = (data: any) => {
  const loanId = pathOr('', ['loanId'], data);
  // If there is no loan id, then we consider this as All Tasks
  return isEmpty(loanId)
    ? `${APP_ROOT}/internal/d/tasks?thisurl=All%20Tasks&taskId=${pathOr(
      '',
      ['taskId'],
      data
    )}`
    : `${APP_ROOT}/internal/applications/${pathOr(
      '',
      ['loanId'],
      data
    )}/works?loanType=${pathOr(
      '',
      ['loanType'],
      data
    )}&thisurl=Tasks&taskId=${pathOr('', ['taskId'], data)}`;
};

export const mkTaskCompletionRedirectionUrl = (data: any) => {
  return `${APP_ROOT}/internal/applications/${pathOr(
    '',
    ['loanId'],
    data
  )}/works?loanType=${pathOr(
    '',
    ['loanType'],
    data
  )}&thisurl=Tasks&taskId=${pathOr('', ['taskId'], data)}`;
};
export const mkAdvisorTaskCompletionRedirectionUrl = (data: any) => {
  return `${APP_ROOT}/internal/d/tasks/?thisurl=All Tasks&${pathOr(
    '',
    ['taskId'],
    data
  )}/${pathOr('', ['taskType'], data)}`;
};
// To Do : we have to set the loanType on task create and use here
export const mkUsersTaskCompletionRedirectUrl = (data: any) => {
  return `${APP_ROOT}/internal/applications/${pathOr(
    '',
    ['loanId'],
    data
  )}/works?loanType=${pathOr(
    '',
    ['loanType'],
    data
  )}&thisurl=Tasks&taskId=${pathOr('', ['taskId'], data)}`;
};

// To Do : we have to set the loanType on task create and use here
export const mkUsersTaskRedirectUrl = (data: any) => {
  return `${APP_ROOT}/internal/applications/${pathOr(
    '',
    ['loanId'],
    data
  )}/works?loanType=${pathOr(
    '',
    ['loanType'],
    data
  )}&thisurl=Tasks&taskId=${pathOr('', ['taskId'], data)}`;
};

export const mkAdvisorTaskRedirectionUrl = (data: any) => {
  return `${APP_ROOT}/internal/d/tasks/?thisurl=All Tasks&${pathOr(
    '',
    ['taskId'],
    data
  )}/${pathOr('', ['taskType'], data)}`;
};

export const mkAdvisorApplicationRedirectionUrl = () => {
  return `${APP_ROOT}${ADVISOR_DASHBOAD}`;
};
export const mkAdvisorAllApprovalUrl = () => {
  return `${APP_ROOT}/internal/d/approval?thisurl=All Approvals`;
};



export const runEventActions = async (
  loanApp: any,
  source: string,
  action: string,
  setLoading: any,
  toastMessage?: any,
  triggeredBy?: string,
  roleId?: string,
  onComplete?: () => void,
  staticData?: any,
  sendNotification?: any
) => {
  setLoading(true);
  if (toastMessage) {
    sendNotification({
      msg: toastMessage,
      variant: 'success'
    });
  }
  const { createEventBridge } = useEventsBridgeHook(source, action);
  const accountId = pathOr({}, [OBJECT_META], loanApp);
  const loanAppId = pathOr('', ['id'], loanApp);
  const data = mkOwnerReference(
    {
      accountId: accountId,
      loan_app_id: loanAppId,
      loan_app_role_id: roleId,
      triggeredBy,
      ...staticData,
    },
    loanApp
  );
  await createEventBridge(data, () => {
    setLoading(false);
    if (onComplete) {
      onComplete();
    }
  });
};

export const mkEvenPayload = async (
  loanApp: any,
  roleId: string,
  triggeredBy?: string,
  config?: string,
  accountId?: string,
) => {
  const accounts = pathOr({}, [OBJECT_META], loanApp);

  const loanAppId = pathOr('', ['id'], loanApp);
  const data = mkOwnerReference(
    {
      accountId: accounts,
      loan_app_id: loanAppId,
      loan_app_role_id: roleId,
      lendsmart_account_id: accountId || pathOr({}, ["account"], accounts),
      triggeredBy,
      config,
    },
    loanApp
  );
  return data;
};


export const mkEncompassEventPayload = async (loanApp: any, roleId: any,) => {
  const enCompassGUID = pathOr("", [OBJECT_META, LABELS, "encompass/loan_guid"], loanApp)
  const data = compose(
    set(lensPath(['eventType']), 'update'),
    set(lensPath(['meta', 'userId']), 'lendsmartapi'),
    set(lensPath(['meta', 'resourceType']), 'Loan'),
    set(lensPath(['meta', 'resourceId']), enCompassGUID),
    set(lensPath(['meta', 'resourceRef']), `/encompass/v3/loans/${enCompassGUID}`),
    set(lensPath(['triggeredBy']), buildLabel(enCompassGUID))
  )({})
  return await data

}

export const mkExcelPopulatorPayload = async (loanApp: any, roleId: string, options: any) => {
  const { borrowerRoleId, coBorrowerRoleId } = options;
  const propertyType = pathOr('', ['spec', 'properties', OBJECT_META, LABELS, 'property_loan_type'], loanApp)
  const data = {
    obejct_meta: pathOr({}, [OBJECT_META], loanApp),
    loan_app_id: pathOr('', ['id'], loanApp),
    loan_type: pathOr('', [TYPE_OF_LOAN], loanApp),
    loan_app_role_id: roleId,
    borrower_loan_app_role_id: borrowerRoleId,
    coborrower_loan_app_role_id: coBorrowerRoleId,
    excel: {
      excel_config: `dti_${toLower(propertyType)}`,
    },
  };

  return data;
};

export const filterBackendTeam = (advisors: any, personas: any) => {
  return advisors.filter((advisorTeamMembers: any) => {
    return contains(getMemberPersona(advisorTeamMembers), personas);
  });
};
export const filterAdvisorProfile = (advisorProfiles: any, personas: any) => {
  return advisorProfiles.filter((advisorProfile: any) => {
    return contains(pathOr('', ['persona'], advisorProfile), personas);
  });
};


/**
  getApplicationsByStatus - this method will be filtering the loan apps depends on given status
 *
 * @param allLoanApps
 * @param status
 */
export const getApplicationsByStatus = (allLoanApps: any, status: any) => {
  /* #1 allLoanApps: send loan app object to filter
     #2 status: you can filter out any thing using this status for eg:not funded*/

  const filterLoanApp = (loanApp: any) => {
    return !contains(
      pathOr(
        '',
        ['status', 'phase'],
        head(pathOr('', ['spec', 'loan_status'], loanApp))
      ),
      status
    );
  };

  return filter(filterLoanApp, allLoanApps);
};

export const getActiveUsers = (allUsers: any) => {
  const filterUser = (user: any) => {
    return contains(pathOr('', ['status'], user), STATUS_ACTIVE);
  };

  return filter(filterUser, allUsers);
};

export const getApplicationsUnassigned = (allLoanApps: any, status: any) => {
  /* #1 allLoanApps: send loan app object to filter
     #2 status: you can filter out any thing using this status for eg:not funded*/

  const filterLoanApp = (loanApp: any) => {
    return isEmpty(
      pathOr(
        '',
        [META_DATA, 'lendsmart_sh/loanapp_assigned_to_advisor_name'],
        head(pathOr('', ['spec', 'loan_status'], loanApp))
      )
    );
  };

  return filter(filterLoanApp, allLoanApps);
};

export const getApplicationsInWorkingQueue = (
  allLoanApps: any,
  status: any
) => {
  /* #1 allLoanApps: send loan app object to filter
     #2 status: you can filter out any thing using this status for eg:not funded*/

  const filterLoanApp = (loanApp: any) => {
    return (
      includes(
        pathOr(
          '',
          ['status', 'phase'],
          head(pathOr('', ['spec', 'loan_status'], loanApp))
        ),
        status
      ) &&
      isEmpty(
        pathOr(
          '',
          ['metadata', 'lendsmart_sh/loanapp_assigned_to_advisor_name'],
          head(pathOr('', ['spec', 'loan_status'], loanApp))
        )
      )
    );
  };

  return filter(filterLoanApp, allLoanApps);
};
//Building a context for single loan app

export const getSingleLoanContext = (loanApp: any, accountId?: string) => {
  const loanRole = accountId
    ? find(
      (item: any) =>
        equals(pathOr('', [OBJECT_META, 'account'], item), accountId),
      pathOr([], ['spec', 'loanapp_roles'], loanApp)
    )
    : head(pathOr([], ['spec', 'loanapp_roles'], loanApp));
  const thisLoanStatus = pathOr(
    '',
    ['status', 'phase'],
    head(pathOr('', ['spec', 'loan_status'], loanApp))
  )
  const assigneeEmail = pathOr('', ['spec', 'loan_status', '0', META_DATA, buildLabel('loanapp_assigned_to_advisor_email')], loanApp);
  //add this before
  return {
    thisLoanType: pathOr('', ['type_of_loan'], loanApp),
    thisLoanProductType: pathOr('', ['sub_type_of_loan'], loanApp),
    thisLoanId: pathOr('', ['id'], loanApp),
    thisLoanRoleId: pathOr('', ['id'], loanRole),
    coBorrowerRoleId: getTheCoBorrowerRoleId(loanApp),
    thisLoanStatusId: pathOr(
      '',
      ['id'],
      head(pathOr('', ['spec', 'loan_status'], loanApp))
    ),
    thisLoanStatus,
    thisAccountId: pathOr('', [OBJECT_META, 'account'], loanApp),
    thisTeamId: pathOr('', ['id'], pathOr('', ['spec', 'teams'], loanApp)),
    thisLoanProductId: pathOr('', [META_DATA, LOAN_PRODUCT_ID], head(pathOr('', ['spec', 'loan_status'], loanApp))),
    thisLoanAmount: pathOr('', ['spec', 'lending_terms', 'terms', 'amount'], loanApp),
    assigneeEmail
  };
};

export const getHistorySingleLoanContext = (loanApp: any) => {
  return {
    thisLoanType: pathOr('', ['loanapp_role', 'loanapp', 'type_of_loan'], loanApp),
    thisLoanId: pathOr('', ['loanapp_role', 'loanapp', 'id'], loanApp),
  };
};
export const sideApplicationMenuList = (
  loanType: any,
  loanId: any,
  counts: any = {}
) => {
  const {
    pendingApprovalsCount,
    newTaskCount
  } = counts


  return [
    {
      title: 'Overview',
      link: `/internal/applications/${loanId}/${loanType}?thisurl=Overview`,
      permissionName: ADVISOR_ONELOAD_OVERVIEW_PERMISSION,
    },
    {
      title: 'Tasks',
      link: `/internal/applications/${loanId}/works?loanType=${loanType}&thisurl=Tasks`,
      permissionName: ADIVSOR_ONELOAN_TASK_PERMISSION,
      tabCount: newTaskCount,
    },
    {
      title: 'Documents',
      link: `/internal/applications/${loanId}/documents?loanType=${loanType}&thisurl=Documents`,
      permissionName: DOCUMENT_PERMISSION,
    },
    {
      title: 'Bank Account',
      link: `/internal/applications/${loanId}/bank?loanType=${loanType}&thisurl=Bank Account`,
      permissionName: BANK_ACCOUNT_PERMISSION,
    },
    {
      title: 'Payment Schedule',
      link: `/internal/applications/${loanId}/fundingschedule?loanType=${loanType}&thisurl=Payment Schedule`,
      permissionName: PAYMENT_SCHEDULE_PERMISSION,
    },
    {
      title: 'Payment Activities',
      link: `/internal/applications/${loanId}/paymentactivities?loanType=${loanType}&thisurl=Payment Activities`,
      permissionName: PAYMENT_ACTIVITIES_PERMISSION,
      tabCount: pendingApprovalsCount,
    },
    {
      title: 'Notes',
      link: `/internal/applications/${loanId}/notes?loanType=${loanType}&thisurl=Notes`,
      permissionName: ADVISOR_ONELOAN_NOTES_PERMISSION,
    },
    {
      title: 'Chat',
      link: `/internal/applications/${loanId}/chat?loanType=${loanType}&thisurl=Chat`,
      permissionName: ADIVSOR_ONELOAN_CHAT_PERMISSION,
    },
    {
      title: 'Activities',
      link: `/internal/applications/${loanId}/activities?loanType=${loanType}&thisurl=Activities`,
      permissionName: ADIVSOR_ONELOAN_ACTIVITY_PERMISSION,
    },
    {
      title: 'FlashSpread',
      link: `/internal/applications/${loanId}/financial/report?thisurl=Financial Reports`,
      permissionName: FINANCIAL_REPORTS_PERMISSION,
    },
    {
      title: 'UW Decision',
      link: `/internal/applications/${loanId}/uwdecision?thisurl=UW Decision`,
      permissionName: UW_DECISION_PERMISSION,
    },
    {
      title: 'Loan Product Advisor',
      link: `/internal/applications/${loanId}/freddiemac/report?thisurl=Loan Product Advisor`,
      permissionName: LOAN_PRODUCT_ADVISOR_PERMISSION,
    }
  ];
};



const adminCerterMenu = (authenticatedUserEmail: string) => {
  const menus = [
    {
      title: 'Notifications',
      link: '/internal/d/notifications?thisurl=Notifications',
      permissionName: ADVISOR_NOTIFICATIONS_PERMISSIONS,
    },
    {
      title: 'Rates',
      link: '/internal/d/rates?thisurl=Rates',
      permissionName: ADVISOR_ADMINCENTER_MORTGAGE_RATES_PERMISSIONS,
    },
    {
      title: 'Bank Accounts',
      link: '/internal/d/bankaccounts?thisurl=Bank Accounts',
      permissionName: ADVISOR_ADMINCENTER_BANK_ACCOUNTS_PERMISSIONS,
    }
  ]

  const directoryMenu = {
    title: 'Directory',
    permissionName: ADMIN_MANAGE_DIRECTORY_PERMISSION,
    subItems: [
      {
        title: 'Users',
        link: '/internal/d/settings/users?thisurl=Users',
        permissionName: ADVISOR_ADMINCENTER_USERS_PERMISSION,
      },
      {
        title: 'Groups',
        link: '/internal/d/settings/roles?thisurl=Groups',
        permissionName: MANAGE_ACCESS_PERMISSIONS,
      },
      {
        title: 'Branches',
        link: '/internal/d/settings/branches?thisurl=Branches',
        permissionName: ADVISOR_ADMINCENTER_BRANCH_MENU,
        color: 'gray'
      },
      {
        title: 'Teams',
        link: '/internal/d/settings/teams?thisurl=Teams',
        permissionName: ADVISOR_ADMINCENTER_ALL_TEAMS_VIEW,
      },
      {
        title: 'Themes',
        link: '/internal/d/settings/themes?thisurl=Themes',
        permissionName: ADVISOR_ADMINCENTER_SITE_BRANDING

      }
    ]
  }

  const gloablSettingMenu = {
    title: 'Global Settings',
    permissionName: ADVISOR_ADMINCENTER_GLOBAL_SETTINGS_MENU,
    subItems: [
      {
        title: 'VarMaps',
        link: '/internal/d/settings/global/varmaps?thisurl=VarMaps',
        permissionName: ADVISOR_ADMINCENTER_VARMAPS_VIEW
      },
      {
        title: 'Documents',
        link: '/internal/d/settings/global/documents?thisurl=Documents',
        permissionName: ADVISOR_ADMINCENTER_VARMAPS_VIEW
      },
      {
        title: 'Permissions',
        link: '/internal/d/settings/global/permissions?thisurl=Permissions',
        permissionName: ADVISOR_ADMINCENTER_VARMAPS_VIEW
      },
      {
        title: 'Features',
        link: '/internal/d/settings/global/features?thisurl=Features',
        permissionName: ADVISOR_ADMINCENTER_VARMAPS_VIEW
      }
    ]
  }

  // Admin Center Mapping allowed only for Getattune Namespace only 
  if (
    equals(APP_LS_NAMESPACE_ID, getNamespaceId()) &&
    includes(authenticatedUserEmail, siteSetting.whoCanAccessInternalGlobalSettingsEmails())
  ) {
    return {
      title: 'Admin Center',
      permissionName: ADVISOR_ADMINCENTER_MENU_PERMISSION,
      subItems: flatten([menus, gloablSettingMenu, directoryMenu]),
    }
  }

  return {
    title: 'Admin Center',
    permissionName: ADVISOR_ADMINCENTER_MENU_PERMISSION,
    subItems: flatten([menus, directoryMenu]),
  }
}

export const sideMenuListAdvisor = (authenticatedUserEmail: string, counts: any = {}) => {
  const {
    invitationCount,
    taskCount,
    servicingApprovalsCount,
    approveCount
  } = counts;

  const helpCenterMenu = {
    title: 'Help Center',
    permissionName: ADVISOR_DASHBOARD_HELP_CENTER_PERMISSIONS,
    subItems: [
      {
        title: 'Self Help Videos',
        link: '/internal/d/helpcenter/videos?thisurl=Self Help Videos',
        permissionName: ADVISOR_DASHBOARD_HELP_CENTER_VIDEOS_VIEW,
      },
      {
        title: 'User Guides',
        link: '/internal/d/helpcenter/guides?thisurl=User Guides',
        permissionName: ADVISOR_DASHBOARD_HELP_CENTER_SHAREPOINTS_VIEW,
      }
    ]
  }

  return [
    {
      title: 'Applications',
      link: ADVISOR_DASHBOAD,
      permissionName: ADVISOR_APPLICATIONS_PERMISSIONS,
    },
    {
      title: 'Invitations',
      link: '/internal/d/invitations?thisurl=Invitations',
      permissionName: ADVISOR_TABS_ADD_NEW_APPLICATION_PERMISSIONS,
      tabCount: invitationCount,
    },
    {
      title: 'All Tasks',
      link: '/internal/d/tasks?thisurl=All Tasks',
      permissionName: ADVISOR_TASKS_PERMISSIONS,
      tabCount: taskCount,
    },
    {
      title: 'All Servicing',
      link: '/internal/d/allpaymentactivities?thisurl=All Servicing',
      permissionName: ADVISOR_ALL_PAYMENT_ACTIVITY_PERMISSIONS,
      tabCount: servicingApprovalsCount,
    },
    {
      title: 'All Approvals',
      link: '/internal/d/approval?thisurl=All Approvals',
      permissionName: ADVISOR_APPROVAL_ACTIVITY_PERMISSIONS,
      tabCount: approveCount,
    },
    {
      title: 'My Teams',
      link: '/internal/d/myteams?thisurl=My Teams',
      permissionName: ADVISOR_DASHBOARD_MY_TEAMS_WRITE,
    },
    {
      title: 'Reports',
      link: '/internal/d/dashboard?thisurl=Reports',
      permissionName: ADVISOR_DASHBOARD_REPORT_PERMISSIONS,
    },
    helpCenterMenu,
    adminCerterMenu(authenticatedUserEmail)
  ];
};
// getDefaultStage used to When stage needs to show different Display Phase than actual status -> phase value
// It will load stage from Name flag instead of value flag of stage config .
export const getDefaultStage = (data: any) => {
  const { loanStatus, rolesID, loanType, subProduct, loanApp } = data
  return pathOr(
    '',
    ['data', 'name'],
    getCurrentStage(
      loanStatus,
      rolesID,
      loanType,
      getNamespaceId(),
      '',
      subProduct,
      loanApp
    )
  )
}

export const getCurrentStage = (
  loanStatus: any,
  userRoles: string[],
  thisLoanType: any,
  namespace_id: any,
  permissions?: any,
  loanProductType?: string,
  loanApp?: any,

) => {
  const treeStags =
    traverseBF(
      pathOr(
        '',
        ['stages'],
        filterLoanStages(namespace_id, thisLoanType, userRoles, loanProductType, permissions, loanApp)
      )
    ) || [];

  const currentStage = head(
    filter(
      (stage: any) =>
        equals(
          pathOr('', ['status', 'phase'], loanStatus),
          pathOr('', ['data', 'value'], stage)
        ),
      treeStags
    )
  );

  return currentStage;
};

export const splitThepath = (locationString: string) => {
  return isNotEmpty(locationString)
    ? split(DATA_PATH_SEPERATOR, locationString)
    : [];
};

export const mapAnswerPreFilFields = (
  loanApp: any,
  textFields: any,
  checkBoxFields: any
) => {
  const answerFn = (field: any) => {
    return set(
      lensPath(['other_args', 'answer']),
      pathOr(
        '',
        splitThepath(pathOr('', ['api_resource_path'], field)),
        loanApp
      ),
      field
    );
  };
  const checkBoxanswerFn = (field: any) => {
    const apiResourcePath = pathOr(
      '',
      splitThepath(pathOr('', ['api_resource_path'], field)),
      loanApp
    );
    const label = pathOr('', ['label'], field);
    return equals(apiResourcePath, label);
  };

  return concat(
    map(answerFn, textFields),
    filter(checkBoxanswerFn, checkBoxFields)
  );
};
export const getBusinessType = (e: any) => {
  return cond([
    [equals(SOLE_PROPRIETOR_LABEL), always(SOLE_PROPRIETOR)],
    [equals(PARTNERSHIP_LABEL), always(PARTNERSHIP)],
    [equals(C_CORP_LABEL), always(C_CORP)],
    [equals(LLC_LABEL), always(LLC)],
    [equals(NON_PROFIT_ORGANISATION_LABEL), always(NON_PROFIT_ORGANISATION)],
    [equals(NON_PROFIT_ORGANIZATION_LABEL), always(NON_PROFIT_ORGANIZATION)],
    [T, always(OTHERS)],
  ])(e);
};
export const mkDocusignEvent = (
  field_mapper: any,
  emailSubject: any,
  emailContent: any,
  loanId: string,
  roleId: string,
  roleName: string,
  accountId: string,
  loanType: string,
  category: string,
  artifact: string,
  documentName: string,
  receivers: any
) => {
  const data = compose(
    set(lensPath(['fields_mapper']), field_mapper),
    set(lensPath(['loan_id']), loanId),
    set(lensPath(['role_id']), roleId),
    set(lensPath(['subject']), emailSubject),
    set(lensPath(['name']), roleName),
    set(lensPath(['template_role_name']), roleName),
    set(lensPath(['conten']), emailContent),
    set(lensPath(['account_id']), accountId),
    set(lensPath(['loan_type']), loanType),
    set(lensPath(['category']), category),
    set(lensPath(['artifact']), artifact),
    set(lensPath(['document_name']), documentName),
    set(lensPath(['receivers']), receivers)
  )({});
  return data;
};

const mkBreakoutCalculation = (loanApp: any, servicingLoan: any) => {
  const address = pathOr('', ['business', 0, 'address'], loanApp);
  const suite = pathOr('', ['business', 0, 'metadata', 'suite'], loanApp);

  const repayment_amount = sum([
    Number(
      pathOr(
        0,
        ['business', 0, META_DATA, buildLabel('loan_amount')],
        loanApp
      ) || 0
    ),
    Number(
      pathOr(
        0,
        ['business', 0, META_DATA, buildLabel('interest_amount')],
        loanApp
      ) || 0
    ),
  ]);

  const total_cost = sum([
    Number(
      pathOr(
        0,
        ['business', 0, META_DATA, buildLabel('originating_fee')],
        loanApp
      ) || 0
    ),
    Number(
      pathOr(
        0,
        ['business', 0, META_DATA, buildLabel('interest_amount')],
        loanApp
      ) || 0
    ),
  ]);
  const payment_start_date =
    pathOr('', ['payment_start_date'], servicingLoan) || pathOr(
      0,
      ['business', 0, META_DATA, buildLabel('onboarding_date')],
      loanApp
    );

  const number_of_payments = Number(
    pathOr(0, ['business', 0, META_DATA, buildLabel('payments')], loanApp) || 0
  );
  const payment_cycle = pathOr(
    '',
    ['business', 0, META_DATA, buildLabel('payment_cycle')],
    loanApp
  );
  const refinanced_amount = subtract(
    Number(
      pathOr(
        0,
        ['business', 0, META_DATA, buildLabel('loan_amount')],
        loanApp
      ) || 0
    ),
    Number(
      pathOr(
        0,
        ['business', 0, META_DATA, buildLabel('originating_fee')],
        loanApp
      ) || 0
    )
  );
  return {
    total_repayment_amount_with_format:
      currencyFormatterWithOutSymbol(repayment_amount),
    total_repayment_amount: repayment_amount,
    total_repayment_amount_with_prefix: formartContractCurrencyFn(
      repayment_amount,
      2
    ),
    total_cost_of_capital_with_prefix: formartContractCurrencyFn(total_cost, 2),
    total_cost_of_capital_with_format:
      currencyFormatterWithOutSymbol(total_cost),
    total_cost_of_capital: total_cost,
    refinanced_amount: formartContractCurrencyFn(refinanced_amount, 2),
    thirteen_schedule_date: findDateByScheduleNumber(
      payment_start_date,
      13,
      payment_cycle
    ),
    last_payment_date: findDateByScheduleNumber(
      payment_start_date,
      number_of_payments,
      payment_cycle
    ),
    bc_monthly_payment_with_prefix: formartContractCurrencyFn(
      divide(repayment_amount, number_of_payments),
      2
    ),
    bc_monthly_payment_with_format: currencyFormatterWithOutSymbol(
      divide(repayment_amount, number_of_payments)
    ),
    bc_monthly_payment: divide(repayment_amount, number_of_payments),
    industry_type: getBusinessType(
      pathOr('', ['business', 0, 'metadata', 'legal_entity'], loanApp)
    ),
    address_and_suite: join(' ', [address, ` Suite# ${suite}`]),
  };
};
const findDateByScheduleNumber = (
  date: any,
  number_of_payments: any,
  paymentFreq: any
) => {
  return isEmpty(date)
    ? ''
    : moment(new Date(date))
      .add(number_of_payments, getPaymentCycle(paymentFreq))
      .format('MM/DD/YYYY');
};
export const getPaymentCycle = (a: any) => {
  return cond([
    [equals(DOWNCASE_MONTHLY_INTERVAL_PERIOD), always('M')],
    [equals(DOWNCASE_WEEKLY_INTERVAL_PERIOD), always('w')],
    [equals(DOWNCASE_DAILY_INTERVAL_PERIOD), always('d')],
    [equals(JOIN_SEMIMONTHLY_INTERVAL_PERIOD_NAME), always('M')],
    [T, always('M')],
  ])(a);
};
export const mkBreakoutApplicantContractEvent = (
  loanApp: any,
  servicingLoan: any,
  bankAccount: any,
  owners: any,
  advisor: any
) => {
  const loanType = pathOr('', ['type_of_loan'], loanApp);
  const applicantionType = pathOr(
    loanType,
    ['spec', 'business', 0, 'object_meta', 'labels', 'type_of_loan'],
    loanApp
  );
  const contractInputs = getContractInputFields(SiteSettings.docuSignContractName(), applicantionType);
  const advisorName = getFullName(advisor);
  const persona = pathOr('', ['persona'], advisor);
  const advisorData = { advisorName, persona };

  const contractPreTextField = pathOr('', ['CONTRACT_PRE_TEXT_FIELDS'], contractInputs);
  const contractPreCheckBoxtField = pathOr('', ['CONTRACT_PRE_FIELDS_CHECK_BOX_FIELDS'], contractInputs);
  const contractEmailSubject = pathOr(doNothingPass, ['CONTRACT_EMAIL_SUBJECT'], contractInputs);
  const contractEmailContent = pathOr(doNothingPass, ['CONTRACT_EMAIL_BODY_CONTENT'], contractInputs);

  return mkDocusignEvent(
    mapAnswerPreFilFields(
      {
        ...pathOr({}, ['spec'], loanApp),
        servicingLoan: servicingLoan,
        loanId: pathOr('', ['application_number'], loanApp),
        advisorData,
        calculations: mkBreakoutCalculation(
          pathOr({}, ['spec'], loanApp),
          servicingLoan
        ),
        bankAccount: pathOr([], ['applicant_bank_account'], bankAccount),
        firstOwnerAddressDesurd: pruneAddress(pathOr('', ['spec', 'business', 0, 'owners', 0, 'address'], loanApp)),
        secondOwnerAddressDesurd: pruneAddress(pathOr('', ['spec', 'business', 0, 'owners', 1, 'address'], loanApp)),
        thirdOwnerAddressDesurd: pruneAddress(pathOr('', ['spec', 'business', 0, 'owners', 2, 'address'], loanApp)),
        fourthOwnerAddressDesurd: pruneAddress(pathOr('', ['spec', 'business', 0, 'owners', 3, 'address'], loanApp)),
      },
      contractPreTextField,
      contractPreCheckBoxtField
    ),
    contractEmailSubject(
      pathOr('', ['spec', 'business', 0, 'business_name'], loanApp)
    ),
    contractEmailContent({
      ownerName: pathOr(
        '',
        ['spec', 'business', 0, 'business_name'],
        loanApp
      ),
    }),
    pathOr('', ['id'], loanApp),
    pathOr('', ['spec', 'loanapp_roles', 0, 'id'], loanApp),
    BORROWER,
    pathOr('', [OBJECT_META, 'account'], loanApp),
    pathOr('', [TYPE_OF_LOAN], loanApp),
    DOCUMENT_REPRESENTS_APPLICANT_CONTRACT,
    APPLICANT_CONTRACT,
    BC_APPLICANT_CONTRACT_DOCUMENT_NAME,
    mkReceivers(owners, loanApp)
  );
};

export const isLoanStatusPending = (loanApp: string) => {
  return equals(
    pathOr(
      '',
      ['status', 'phase'],
      head(pathOr('', ['spec', 'loan_status'], loanApp))
    ),
    STATUS_SAVED_PREQUALIFICATION
  );
};
export const isLoanStatusDeclined = (loanApp: string) =>
  equals(
    pathOr(
      '',
      ['status', 'phase'],
      head(pathOr('', ['spec', 'loan_status'], loanApp))
    ),
    STATUS_DECLINED
  );
export const pushOwerExperian = (
  owners: any,
  loanApp: any,
  setLoading: any,
  onCancel: any,
  onComplete: () => void,
  run_uw_excelmanager: string,
  run_experian: string
) => {
  const [sendNotification] = useNotification();

  return new Promise((resolve, reject) => {
    if (equals(length(owners), 0)) {
      sendNotification({
        msg: 'Select any one of the listed owners',
        variant: 'warning',
      });
      resolve('');
      return;
    }

    const { createEventBridge } = useEventsBridgeHook(
      EVENTS_SOURCE_EXPERIAN,
      EVENTS_ACTION_CREDIT_CHECK
    );

    const experianConsumers = map((d: any) => {
      const ownersName = pathOr('', ['name'], d);
      const ownersAddress: any = pathOr({}, ['address'], d);
      const ownersDob = pathOr('', ['dob'], d);
      const ownersSSN = pathOr('', ['tin_ein_ssn'], d);
      const { street, city, state, zipcode } = ownersAddress;
      return {
        name: ownersName.toUpperCase(),
        dob: ownersDob.replace(/[^\w\s]/gi, ''),
        ssn: ownersSSN.replace(/[^\w\s]/gi, ''),
        address: {
          street,
          city,
          state,
          zipcode,
        },
      };
    }, owners);

    const data = mkOwnerReference(
      {
        owners: experianConsumers,
        run_uw_excelmanager,
        run_experian,
        object_meta: { owner_references: [], namespace: getNamespaceName() },
      },
      loanApp
    );

    Promise.all([createEventBridge(data, () => setLoading(false))])
      .then((response) => {
        resolve(response);
        if (onComplete) {
          onComplete();
          onCancel();
        }
      })
      .catch((err) => {
        if (onComplete) {
          onComplete();
        }
        reject(err);
      });
  });
};

export const mkOwnerReference = (data: any, loanApp: any) => {
  const { thisLoanId, thisLoanRoleId, thisLoanStatusId } =
    getSingleLoanContext(loanApp);
  const objectMeta = pathOr({}, ['object_meta'], loanApp);
  return compose(
    setOwnerReference(thisLoanRoleId, KIND_LOANAPP_ROLE),
    setOwnerReference(thisLoanId, KIND_LOANAPP),
    setOwnerReference(thisLoanStatusId, KIND_LOAN_STATUS)
  )({
    ...data,
    object_meta: objectMeta,
  });
};
export const mkNotificationForReassign = (
  advisorProfile: any,
  thisLoan: string
) => {
  const assigneeName = getFullName(advisorProfile);
  const name = pathOr('', ['name'], thisLoan);
  return {
    notificationTitle: `<b>${assigneeName}</b> has updates for you`,
    notificationMessage: `${name} has been assigned to you. Please check it out!`,
    notificationType: 'INFO',
    notificationRedirection: mkAdvisorApplicationRedirectionUrl(),
  };
};




const mkReceivers = (owners: any, loanApp: any) => {
  const receivers = mapIndexed((x: any, index: number) => {
    return compose(
      set(lensPath(['name']), `Borrower${index + 1}`),
      set(lensPath(['template_role_name']), `Borrower${index + 1}`),
      set(
        lensPath(['email']),
        pathOr(
          '',
          ['spec', 'business', 0, META_DATA, `owner_${index + 1}_email_id`],
          loanApp
        )
      )
    )({});
  }, owners);

  return receivers;
};

/** This code is needed when we activate experian for Mortgage. Will depend on the Lender.
 * For demo purposes we use the static 11111112 as the SSN.
 * tin_ein_ssn: pathOr('111111112', ['profile','social_security_no'], borrower)
 **/
const mkMortgageOwners = (borrowers: any, accounts: any) =>
  map(
    (borrower: any) => ({
      name: pathOr('', ['profile', 'name'], borrower),
      tin_ein_ssn: pathOr(
        '',
        ['profile', 'social_security_no'],
        borrower
      ),
      dob: pathOr('', ['profile', 'date_of_birth'], borrower),
      address: pathOr(
        '',
        ['addresses', 'present', 'street'],
        borrower
      ),
      ownerRef: pathOr([], [OBJECT_META, 'owner_references'], borrower),
      email: pathOr('', ['email'], find((item: any) => equals(pathOr('', ['id'], item),
        pathOr('', [OBJECT_META, 'account'], borrower)), accounts)),
      borrower,
    }),
    borrowers
  );

export const getOwnersFromLoan = (loanApp: any, borrowersInfo?: any) => {
  // FIXME: We need to find a way to keep the loan app spec fresh, but How do we do that?
  //  Since in the workflow the borrowers is kept updated but the `loanapp -> spec -> borrowers`
  //  is  not mutated  with the current status of the loan we cant use that to get the borrowers info.
  // So in that  case the borrowers information is got from the reducer and sent.

  const borrowers = borrowersInfo
    ? [borrowersInfo]
    : pathOr([], ['spec', 'borrowers'], loanApp);
  const accounts = pathOr([], ['spec', 'user_accounts'], loanApp)
  return cond([
    [() => isMortgage(pathOr('', ['type_of_loan'], loanApp)) && isNotEmpty(borrowers), () => mkMortgageOwners(borrowers, accounts)],
    [T, always(pathOr([], ['spec', 'business', 0, 'owners'], loanApp))],
  ])(pathOr('', ['type_of_loan'], loanApp));
};

export const isMortgage = (data: any) => {
  return includes(data, MORTGAGE);
};

const advisorByEmail = (advisorEmail: any, advisorProfiles: any) => {
  const advisor = advisorEmail
    ? find(
      (item: any) =>
        equals(pathOr('', ['email'], item), advisorEmail),
      pathOr([], ['data', 'advisor_profiles'], advisorProfiles)
    )
    : {};

  const advisorFullname = getFullName(advisor);
  const advisorPersona = pathOr('', ['persona'], advisor);
  const advisorAvatar = pathOr('', ['avatar'], advisor);

  return {
    advisorFullname,
    advisorPersona,
    advisorAvatar
  }
}

export const getStatusReason = (status: string) => cond([
  [equals(STATUS_DECLINED), always(`We're sorry to inform you that your application was not approved at this time and has been moved to the Declined stage.`)],
  [equals(STATUS_WITHDRAW), always(`We're sorry to inform you that your application has been withdrawn. This action will in no way affect you from reapplying in the future!`)],
  [T, always(`your application has been moved to ${status} stage`)],
])(status)

export const mkDashboardRow = (thisLoan?: any, advisorProfiles?: any) => {
  const name = pathOr('', ['name'], thisLoan);
  const thisLoanType = pathOr('', ['type_of_loan'], thisLoan);
  const thisLoanId = pathOr('', ['id'], thisLoan);

  const thisLoanRoleId = pathOr('', [''], thisLoan);
  const thisLoanStatusId = pathOr(
    '',
    ['id'],
    head(pathOr('', ['spec', 'loan_status'], thisLoan))
  );
  const thisLoanStatus = pathOr('', ['loanstatus_phase'], thisLoan);
  const thisAccountId = pathOr('', ['object_meta', 'account'], thisLoan);
  const thisTeamId = pathOr('', ['id'], pathOr('', ['spec', 'teams'], thisLoan));
  const assignedToAdvisorEmail = pathOr('', ['assigned_to_advisor_email'], thisLoan);

  const { advisorFullname, advisorPersona, advisorAvatar } = advisorByEmail(assignedToAdvisorEmail, advisorProfiles);

  const applicationNumber = pathOr('', ['application_number'], thisLoan);
  const applicantEmail = pathOr('', ['email'], thisLoan);

  const applicationCreatedDate = dateWithTimeStamp(
    pathOr('', ['created_at'], thisLoan)
  );

  const loanStatusObject = head(pathOr('', ['spec', 'loan_status'], thisLoan));;
  const subProductName = pathOr('', ['sub_type_of_loan'], thisLoan);

  const applicationURL = getOneLoanAppURL(thisLoanId, thisLoanType);
  const loanPriority = pathOr('', ['loanapp_labels', 'loan_priority'], thisLoan);
  const collateralType = pathOr('', ['loanapp_labels', 'collateral_type'], thisLoan);
  const data = {
    name,
    thisLoanId,
    thisLoanType,
    applicationURL,
    thisLoanRoleId,
  };

  return {
    name,
    thisLoanType,
    thisLoanId,
    thisLoanRoleId,
    thisLoanStatusId,
    thisLoanStatus,
    thisAccountId,
    thisTeamId,
    applicationNumber,
    applicantEmail,
    applicationCreatedDate,
    advisorFullname,
    advisorPersona,
    advisorAvatar,
    loanStatusObject,
    subProductName,
    applicationURL,
    data,
    loanPriority,
    collateralType
  };
};


const findFirstLinkWithPermission = (menus: any, permissions: any) => {
  const search: any = reduce(
    (acc: any, item: any) => {
      if (acc) return acc; // If we've already found a result, return it

      const hasPermission = canGuard(permissions, item.permissionName)
      if (hasPermission && item.link) return item.link;

      if (item.subItems) return search(item.subItems); // Recursively search subItems

      return null;
    }, null);

  return search(menus);
};


export const getHomeRouteOfRole = (
  permissions: any,
  accountEmail: string,
) => {
  const hadAccessToDefaultHome = canGuard(permissions, ADVISOR_APPLICATIONS_PERMISSIONS)
  if (hadAccessToDefaultHome) {
    return
  }
  const advisorMenus = sideMenuListAdvisor(accountEmail)
  const nextRoute = findFirstLinkWithPermission(advisorMenus, permissions)

  return returnIsNotEmptyOrTrue(
    nextRoute,
    nextRoute
  )

}